import {
  BaseQueryFn,
  createApi,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
} from "@reduxjs/toolkit/query/react"
import { getAuth0 } from "src/utils/auth0Utils"

const BASE_URL = import.meta.env.VITE_MBLS_DELIVERY_BE_URL

// Custom baseQuery to handle 401 errors and redirect to login
const customBaseQuery: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  const rawBaseQuery = fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: async (headers) => {
      headers.set("Content-Type", "application/json")
      headers.set("ts", Date.now().toString())
      try {
        const auth0 = getAuth0()
        const token = await auth0.getAccessTokenSilently({
          authorizationParams: {
            audience: "mbls-global-api",
          },
        })
        if (token) {
          headers.set("Authorization", `Bearer ${token}`)
          headers.set("ts", `${Date.now()}`)
        }
      } catch (error) {
        console.error("Error fetching Auth0 token:", error)
      }
      return headers
    },
  })
  try {
    const result = await rawBaseQuery(args, api, extraOptions)
    if (
      result?.error?.status === 401 ||
      result?.error?.status === "FETCH_ERROR"
    ) {
      // Redirect to login (Auth0 or fallback)
      try {
        const auth0 = getAuth0()
        auth0.loginWithRedirect()
      } catch (e) {
        window.location.href = "/login"
      }
    }
    return result
  } catch (error) {
    console.error("Error in rawBaseQuery:", error)
    throw error
  }
}

export const baseApi = createApi({
  reducerPath: "baseApi",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({}),
})
